import { PATHS } from '@navigators/Root/App/constants';

export const useRedirectEmailPath = ({
  skipEmailValidation,
  isEmailConfirmed,
}) => (!isEmailConfirmed && !skipEmailValidation
  ? `/${PATHS.CONFIRM_EMAIL}`
  : null
);
